// widget/src/components/ReturningVisitorGreeting.tsx
// Per spec §3.3 + §7.7: greeting line above input box (NOT in message stream)
// when cookie hits. Recognition without restoration — bridges "did the bot
// forget me?" gap without conversation-restore complexity.

export interface ReturningVisitorGreetingProps {
  name: string
}

export function ReturningVisitorGreeting({ name }: ReturningVisitorGreetingProps) {
  if (!name) return null
  return (
    <div
      data-testid="returning-greeting"
      className="px-4 py-2 text-sm text-muted-foreground border-b border-border"
    >
      Welcome back, {name}!
    </div>
  )
}
